import { FC, useState } from 'react';
import { IModal } from '@epam/uui-core';
import {
  Button,
  FlexRow,
  ModalBlocker,
  ModalHeader,
  ModalWindow,
  Panel,
  Text,
  TextInput,
} from '@epam/promo';
import { RulesHint } from './RulesHint';
import css from './UserGroupEditModal.module.scss';

export interface IUserGroupEditModal {
  title: string;
  helperText: string;
  showRulesHint?: boolean;
  confirmCaption: string;
  initialValue?: string;
  placeholder?: string;
  onConfirm: (value: string) => void;
  modalProps: IModal<void>;
}

export const UserGroupEditModal: FC<IUserGroupEditModal> = ({
  title,
  helperText,
  showRulesHint,
  confirmCaption,
  initialValue = '',
  onConfirm,
  modalProps,
  placeholder,
}) => {
  const [value, setValue] = useState(initialValue);

  const handleConfirm = () => {
    onConfirm(value);
    modalProps.abort();
  };

  return (
    <ModalBlocker
      key={modalProps.key}
      abort={modalProps.abort}
      isActive={modalProps.isActive}
      success={modalProps.abort}
      zIndex={modalProps.zIndex}>
      <ModalWindow width="420">
        <Panel background="white">
          <ModalHeader borderBottom title={title} onClose={modalProps.abort} />
          <Panel cx={css.modalBody}>
            <Text cx={css.inputTitle}>{helperText}</Text>
            <TextInput
              placeholder={placeholder}
              value={value}
              onValueChange={(val) => setValue(val ?? '')}
            />
            {showRulesHint && <RulesHint />}
            <FlexRow cx={css.modalActions}>
              <Button
                caption={confirmCaption}
                color="blue"
                isDisabled={!value.trim()}
                onClick={handleConfirm}
              />
              <Button
                caption="Cancel"
                color="gray"
                fill="solid"
                onClick={modalProps.abort}
              />
            </FlexRow>
          </Panel>
        </Panel>
      </ModalWindow>
    </ModalBlocker>
  );
};
